export default __webpack_public_path__ + "static/outline-prestige-75c6009d33ace5e5f145206caa99cc04.svg";